<div *ngIf="isSameDay">
  <div class="properties">
    <ion-icon name="calendar"></ion-icon>
    <p class="text">{{ job?.timestamps?.startTime | amCalendar: dateOnlyFormat }}</p>
  </div>
  <div class="properties">
    <ion-icon name="time"></ion-icon>
    <p class="text">{{ getTime(job?.timestamps?.startTime) }} - {{ getTime(job?.timestamps?.endTime) }}</p>
  </div>
</div>
<div *ngIf="!isSameDay">
  <div class="properties">
    <ion-icon name="calendar"></ion-icon>
    <div>
      <p class="text">Start time: {{ getCombinedDate(job?.timestamps?.startTime) }}</p>
      <p class="text">End time: {{ getCombinedDate(job?.timestamps?.endTime) }}</p>
    </div>
  </div>
</div>
